import React from 'react';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { getDisponibilidadeColumns } from './tanStackColumns';

const DisponibilidadeTable = ({
  data,
  loading,
  totalRegistros,
  paginaAtual,
  quantidadePorPagina,
  setPaginaAtual,
  setQuantidadePorPagina,
  onRowClick
}) => <TanStackTable columns={getDisponibilidadeColumns()} data={data} onRowClick={onRowClick} isSortable={true} withPagination={true} pageSizeOptions={[5, 10, 25, 50, 100]} enableRowColors={true} loading={!!loading} className="mt-3" manualPagination={true} totalItems={totalRegistros} controlledPagination={{
  pageIndex: Math.max(0, (paginaAtual || 1) - 1),
  pageSize: quantidadePorPagina || 5
}} onPaginationChange={next => {
  if (next && typeof next.pageSize === 'number') {
    setQuantidadePorPagina(next.pageSize);
  }

  if (next && typeof next.pageIndex === 'number') {
    setPaginaAtual(next.pageIndex + 1);
  }
}} />;

export default DisponibilidadeTable;
